import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const SellAssets = lazy(() => import('../../pages/SellAssets/SellAssetsPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<SellAssets />} />
    </Routes>
  );
}

export default PagesRoute;
